import React, { useMemo } from "react"
import { ApplicationType } from "../../../models/workshop/common"
import { transformApplicationToAgent } from "../../AgentList/helpers/transformApplicationToAgent"
import { useAppSelector } from "../../../store/hooks"
import { selectApplicationTemplates, selectReleasedApplications } from "../../../store/workshop/selectors"
import TypeFormCard from "../../TypeFormCard/TypeFormCard"
import AgentIcon from "../../AgentIcon/AgentIcon"
import { Agent, AgentType } from "../../../models/agent"
import styles from "../AddAgentBlockForm.module.scss"
import { ApplicationInstance } from "../../../models/workshop/instance"

export const useReleasedAgents = (handleSelect: (agent: Agent, application?: ApplicationInstance) => void) => {
    const releasedApplications = useAppSelector(selectReleasedApplications)
    const applicationTemplates = useAppSelector(selectApplicationTemplates)

    const releasedAgents = useMemo(
        () =>
            [...releasedApplications]
                .filter(application => application.ApplicationType === ApplicationType.AGENT)
                .sort((a, b) => a.Audit.CreateTimestamp - b.Audit.CreateTimestamp)
                .map(transformApplicationToAgent),
        [releasedApplications]
    )

    const renderReleasedAgents = () =>
        releasedAgents.map(agent => {
            const releasedAgent = releasedApplications.find(app => app.Id === agent.Id)
            const template = applicationTemplates.find(template => template.Id === releasedAgent?.TemplateId)

            return (
                <TypeFormCard
                    key={agent.Id}
                    onSelect={() => handleSelect(agent, releasedAgent)}
                    icon={
                        <AgentIcon
                            logo={releasedAgent?.Icon}
                            type={AgentType.AppstoreAgent}
                            className={styles.addAgentBlockForm__agentTypeIcon}
                        />
                    }
                    title={agent.ApplicationTitle ?? ""}
                    description={template?.Description}
                    mini
                />
            )
        })

    return { renderReleasedAgents }
}
